import { parseAgentClass, parseRarityName } from '$lib/utils';
import { faCalendarDays, faPersonMilitaryRifle, faStars } from '@fortawesome/pro-solid-svg-icons';

import isDarkColor from 'is-dark-color';

export default (data) => {
  return {
    relationKey: 'container',
    relationItem: data.item.container,
    content: {
      collection: data.item.container.lootlists.find((x) => x.collection)?.collection || null,

      stickyBox: {
        subtitle: `${parseRarityName(data.item.rarity)} Souvenir Package`,
        title: data.item.name,
        link: {
          label: `Other Souvenir Packages`,
          href: `/skins/souvenir-packages`,
        },
      },
      priceFetcher: (item) => item.container.steamValue,
      infoBoxes: [
        {
          icon: faPersonMilitaryRifle,
          label: 'Package Contains',
          value: `${data.item.container.lootlists.flatMap((x) => x.items).length} Skins`,
          // value: `${3} Skins`
        },
        {
          icon: faStars,
          label: 'Rarity',
          value: parseRarityName(data.item.rarity),
          style: `--col-rarity:${data.item.rarity.hexColor}`,
          modifiers: ['rarity', data.item.rarity.slug].concat(!isDarkColor(data.item.rarity.hexColor) ? ['dark'] : []),
        },
      ],
    },
  };
};
